import React from 'react';

const menuItems = [
    {
        path: "/dashboard/profile",
        label: "Mon profil",
    },
    {
        path: "/dashboard/courses",
        label: "Mes formations",
    },
];

export default menuItems;


// WEBPACK FOOTER //
// ./src/features/Dashboard/menuItems.js